import { downloadFile } from '@/utils'

// import moment from 'moment'
// import 'moment/locale/es-mx'

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 * @return {Object} Paid report
 */
const paramsTransformer = ({
  // supervisors = [],
  // dateEnd,
  // dateStart,
  // iva = [],
  // families = [],
  // status = [],
  // jobType,
  type
}) => {
  let finalString = []
  // if(dateStart) {
  //   finalString.push(
  //     `?from=${dateStart ? moment(dateStart).format('YYYY/MM/DD') : null}`
  //   )
  // }
  // if(dateEnd) {
  //   finalString.push(
  //     `&to=${dateEnd ? moment(dateEnd).format('YYYY/MM/DD') : null}`
  //   )
  // }
  // if (supervisors.length) {
  //   finalString.push(`&supervisor=${supervisors.join(',')}`)
  // }
  // if (families.length) {
  //   finalString.push(`&services=${families.join(',')}`)
  // }
  // if (iva.length === 1) {
  //   finalString.push(`&iva=${iva[0]}`)
  // }
  // if (jobType) {
  //   finalString.push(`&job=${jobType}`)
  // }
  // if (status.length) {
  //   finalString.push(`&status=${status.join(',')}`)
  // }
  if (type) {
    finalString.push(`&${type}`)
  }
  return finalString.join('').replace('&', '?')
}

export default (url, payload, fileName = `Archivo.xlsx`) => 
  downloadFile(`${url}/${paramsTransformer(payload)}`,fileName)
